export interface ActivePageLike {
  displayName?: string | null;
  name?: string | null;
}

export const extractActivePageName = (
  activePage: ActivePageLike | null | undefined,
): string | null => {
  if (!activePage) {
    return null;
  }

  return activePage?.displayName || activePage?.name || null;
};
